module.exports = __webpack_public_path__ + "media/images/impact-report-decent-work-11c4c71e570b9b125e6f615de6fcb4d4.png";